import api from './index'

const resource = 'offer_attachments'

export default {
  getCvCertificateAttachment (id) {
    return api.get(`${resource}/${id}/download_attachment`, { responseType: 'arraybuffer' })
  }
}
